/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider"; 

const LpoEntryRedirect = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      // fallback - shouldn't happen if page is protected
      navigate("/");
    } else if (user.is_b2c_user) {
      navigate("/secure/voice");
    } else {
      navigate("/lpo-form");
    }
  }, [user, navigate]);

  return null; // or a spinner if desired
};

export default LpoEntryRedirect;